import Swiper from 'swiper';
import { Navigation, Scrollbar, Pagination, EffectFade } from 'swiper/modules';

export default function latestNewsSlider() {
  const swiperContainer = document.querySelector('.latest-news__slider.swiper') as HTMLElement;
  const prevEl = swiperContainer?.querySelector('.swiper-button-prev') as HTMLElement;
  const nextEl = swiperContainer?.querySelector('.swiper-button-next') as HTMLElement;
  const pagination = swiperContainer?.querySelector('.swiper-pagination') as HTMLElement;
  const scrollbar = swiperContainer?.querySelector('.swiper-scrollbar') as HTMLElement;

  swiperContainer && new Swiper(swiperContainer, {
    modules: [Navigation, Scrollbar, Pagination, EffectFade],
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      prevEl,
      nextEl
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
    breakpoints: {
      768: {
        pagination: {
          el: pagination,
          clickable: true,
        },
      }
    }
  })
}